import script from "./pixelItem.vue?vue&type=script&setup=true&lang=js"
export * from "./pixelItem.vue?vue&type=script&setup=true&lang=js"

import "./pixelItem.vue?vue&type=style&index=0&id=cc36c9a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc36c9a0"]])

export default __exports__